import { render, staticRenderFns } from "./PositionAdress.vue?vue&type=template&id=6da1a1a8&scoped=true&"
import script from "./PositionAdress.vue?vue&type=script&lang=js&"
export * from "./PositionAdress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da1a1a8",
  null
  
)

export default component.exports